import { render, staticRenderFns } from "./letter.vue?vue&type=template&id=0f069d6a&scoped=true"
import script from "./letter.vue?vue&type=script&lang=js"
export * from "./letter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f069d6a",
  null
  
)

export default component.exports